<template>
  <v-card
    class="pb-12"
    v-touch="{
      right: () => swipe(),
    }"
  >
    <div class="container">
      <v-alert
        v-model="isUrlCopy"
        closable
        variant="tonal"
        :text="`Ссылка на подборку скопирована`"
        color="#ff8351"
        style="margin-bottom: 20px"
      ></v-alert>
      <div class="header flex mb-3">
        <div
          :class="
            $store.state.isMobile
              ? 'header__title flex align-center justify-space-between mb-4'
              : 'header__title flex align-end justify-space-between mb-8'
          "
        >
          <div cols="1" v-if="$store.state.isMobile">
            <button
              class="btn-reset close__filter align-self-center"
              @click="backSwitch"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17 10C17 10.1989 16.921 10.3897 16.7803 10.5303C16.6397 10.671 16.4489 10.75 16.25 10.75L5.61201 10.75L9.77001 14.71C9.9064 14.8494 9.98312 15.0365 9.9839 15.2315C9.98467 15.4266 9.90943 15.6142 9.77414 15.7547C9.63885 15.8952 9.45416 15.9775 9.25923 15.9841C9.0643 15.9907 8.87447 15.921 8.73001 15.79L3.23001 10.54C3.15742 10.47 3.09968 10.3862 3.06025 10.2934C3.02081 10.2006 3.00049 10.1008 3.00049 10C3.00049 9.89919 3.02081 9.79941 3.06025 9.70663C3.09968 9.61385 3.15742 9.52997 3.23001 9.46001L8.73001 4.21001C8.8002 4.13826 8.88408 4.08133 8.97668 4.04259C9.06928 4.00386 9.16871 3.9841 9.26908 3.9845C9.36945 3.9849 9.46873 4.00544 9.56101 4.04491C9.6533 4.08437 9.73673 4.14196 9.80635 4.21426C9.87598 4.28657 9.93038 4.37211 9.96634 4.46582C10.0023 4.55953 10.0191 4.65951 10.0157 4.75982C10.0123 4.86014 9.98881 4.95875 9.9466 5.04983C9.9044 5.1409 9.84435 5.22257 9.77001 5.29001L5.61201 9.25001L16.25 9.25001C16.4489 9.25001 16.6397 9.32902 16.7803 9.46968C16.921 9.61033 17 9.80109 17 10Z"
                  fill="black"
                />
              </svg>
            </button>
          </div>
          <div class="logo" v-else>
            <svg
              width="71"
              height="61"
              viewBox="0 0 91 61"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.6635 10.082C18.4274 10.8168 17.0504 11.8015 15.5672 13.0717C14.772 11.3842 14.1088 9.31956 13.6248 7.13302C16.2403 3.74996 18.532 2.39136 18.532 2.39136C18.5618 4.07278 18.8369 7.06889 19.6635 10.082Z"
                fill="#EC4900"
              />
              <path
                d="M19.6635 10.082C18.4274 10.8168 17.0504 11.8015 15.5672 13.0717C14.772 11.3842 14.1088 9.31956 13.6248 7.13302C16.2403 3.74996 18.532 2.39136 18.532 2.39136C18.5618 4.07278 18.8369 7.06889 19.6635 10.082Z"
                fill="url(#paint0_linear_374_747)"
              />
              <path
                d="M18.4074 10.4462C17.7359 8.4486 17.4362 6.44144 17.3521 5.30984C17.3521 5.30984 15.8605 6.31236 14.228 8.69025L15.2606 12.5076L18.4872 11.2337"
                fill="url(#paint1_linear_374_747)"
              />
              <path
                d="M29.2121 60.1947C28.8911 60.1947 28.5704 60.191 28.2575 60.1833C-0.956879 59.5222 -4.86076 29.9872 5.3398 17.0654C8.01469 13.6794 6.29467 5.83281 14.5509 0C14.4117 1.56938 14.3963 3.22764 14.4969 4.83162C14.6129 6.7797 14.899 8.65061 15.3511 10.216C16.8045 9.32685 18.1303 8.66604 19.2939 8.2059C21.2614 7.41363 22.7842 7.17012 23.7545 7.23186C24.9258 7.31303 26.1587 8.42626 28.0991 8.89784C32.1848 8.2059 35.451 7.02321 39.5712 4.94739C43.4637 15.6001 33.236 21.6418 24.6588 32.0973C17.3147 41.0652 16.5453 54.331 29.2121 60.1947Z"
                fill="url(#paint2_linear_374_747)"
              />
              <path
                d="M28.2572 60.1833L25.7362 60.0858C24.8984 60.0145 24.0627 59.9083 23.2249 59.821C22.393 59.6938 21.5664 59.5275 20.7358 59.3822C19.9191 59.1759 19.0986 58.975 18.2871 58.7448C15.063 57.7455 12.0056 56.1671 9.36242 54.0409C8.07381 52.9445 6.82937 51.7748 5.79891 50.4237C5.24296 49.7804 4.79533 49.0571 4.30645 48.3638C4.07624 48.008 3.87318 47.6346 3.65549 47.2708L3.334 46.7215C3.23101 46.5363 3.14372 46.3425 3.04765 46.1536L2.48451 45.0124L2.00068 43.8359C1.92191 43.6389 1.83568 43.4449 1.76329 43.2458L1.5613 42.6428C1.43063 42.2396 1.28319 41.8412 1.16636 41.4337C0.953987 40.613 0.711009 39.7989 0.568362 38.9622L0.44461 38.3384L0.383135 38.0265L0.340287 37.7114L0.169165 36.451C-0.177605 33.0796 -0.000894719 29.6468 0.788718 26.3475C1.18259 24.7005 1.69649 23.0749 2.41159 21.5348C3.1187 19.9958 3.94717 18.498 5.01143 17.1697C6.0733 15.9008 6.45386 14.2319 6.86557 12.6146C7.26424 10.9848 7.66423 9.33588 8.29124 7.76197C8.91505 6.1894 9.76241 4.70306 10.824 3.3889C11.3576 2.73422 11.9447 2.12584 12.5658 1.55711C13.1891 0.989189 13.8643 0.484604 14.5509 0.000244141C13.1987 0.998504 11.9628 2.15405 10.9347 3.47645C9.91384 4.80392 9.11358 6.28973 8.53475 7.85592C7.94234 9.41971 7.56736 11.054 7.19264 12.6929C7.00289 13.5123 6.80622 14.3354 6.53397 15.1445C6.39292 15.5471 6.24096 15.9495 6.03737 16.3327C5.94449 16.5278 5.82473 16.7117 5.70896 16.8959L5.33611 17.4188L4.6101 18.4333L3.96287 19.5002L3.8008 19.7666L3.65629 20.0431L3.36966 20.5975L3.08277 21.1519C2.99335 21.3397 2.91564 21.533 2.83128 21.7232C2.13668 23.2373 1.63954 24.8372 1.2603 26.458C0.498901 29.7045 0.343481 33.0825 0.697436 36.3929L0.859777 37.6318L0.900229 37.9416L0.95931 38.2481L1.078 38.8616C1.21373 39.6847 1.44899 40.4847 1.65338 41.2922C1.76595 41.693 1.9094 42.0844 2.03555 42.4812L2.23089 43.0745C2.30088 43.2703 2.38498 43.4611 2.46136 43.6546L2.93081 44.8123L3.47825 45.9348C3.57139 46.1209 3.65602 46.3117 3.75635 46.494L4.06932 47.0342C4.28143 47.3922 4.47863 47.7597 4.70298 48.1102C5.17989 48.792 5.61528 49.505 6.15819 50.1381C7.16736 51.4653 8.37188 52.6278 9.62163 53.7272C12.1898 55.8554 15.1848 57.4559 18.3649 58.4976C21.5459 59.5581 24.9018 60.0345 28.2572 60.1833Z"
                fill="url(#paint3_linear_374_747)"
              />
              <path
                d="M29.2123 60.1948C-0.252997 56.9829 2.51078 24.8464 14.9764 18.9247C13.2998 18.6299 10.2073 18.6626 10.2073 18.6626C14.418 13.794 34.2874 13.7283 39.5712 4.94751C43.4636 15.6002 33.2359 21.6419 24.6588 32.0975C17.3149 41.0653 16.5455 54.3312 29.2123 60.1948Z"
                fill="url(#paint4_linear_374_747)"
              />
              <path
                d="M29.467 23.7988C27.3757 25.9866 25.219 28.2477 23.1046 30.826C18.3773 36.593 16.3944 43.6897 17.7937 49.8046C18.4159 52.5064 19.6491 54.9183 21.4503 56.9824C15.2271 54.8875 10.3995 44.5671 11.9417 35.932C10.8902 37.5554 10.0168 39.322 9.41772 41.1617C7.17955 18.7274 34.1789 17.4441 38.2685 7.80399C39.1963 13.2621 35.5473 17.4326 29.467 23.7988Z"
                fill="url(#paint5_linear_374_747)"
              />
              <path
                d="M29.4671 23.7988C27.3759 25.9866 25.2191 28.2477 23.1047 30.826C18.3774 36.593 16.3945 43.6897 17.7938 49.8046C18.416 52.5064 19.6493 54.9183 21.4504 56.9824C12.0036 49.6769 14.2279 35.1107 19.6636 28.2024C18.0865 28.5966 15.4774 30.385 15.4774 30.385C19.6636 21.2285 38.4118 17.0654 38.2686 7.80399C39.1964 13.2621 35.5474 17.4326 29.4671 23.7988Z"
                fill="url(#paint6_linear_374_747)"
              />
              <path
                d="M11.9417 35.9324C10.932 37.5893 10.0907 39.3501 9.52734 41.1978L9.36474 41.7311L9.30273 41.1736C9.19361 40.1942 9.13267 39.2085 9.1356 38.2206C9.14518 37.233 9.21091 36.2446 9.34717 35.2636C9.62395 33.3028 10.2073 31.376 11.1079 29.6027C11.9997 27.825 13.1888 26.2053 14.557 24.7711C15.2404 24.0525 15.9675 23.3771 16.7243 22.7397C17.4849 22.1063 18.277 21.5131 19.0868 20.9489C22.3357 18.6964 25.8521 16.9085 29.3145 15.0783C31.0414 14.154 32.7511 13.1949 34.3489 12.0713C35.1422 11.5042 35.9092 10.8937 36.5871 10.1911C36.9296 9.84298 37.2372 9.46321 37.5284 9.07093C37.811 8.67227 38.059 8.24912 38.2677 7.80441C38.0811 8.25843 37.8528 8.69569 37.5875 9.11112C37.3133 9.52016 37.0126 9.91298 36.6805 10.2781C36.021 11.0132 35.2684 11.6585 34.4876 12.2603C32.9129 13.4512 31.2035 14.4396 29.4957 15.4089L24.3503 18.2642C22.6474 19.2294 20.9726 20.2418 19.3801 21.3675C18.5838 21.9301 17.8096 22.522 17.0647 23.1472C16.3164 23.7681 15.5989 24.4251 14.9248 25.1235C13.5755 26.5177 12.4053 28.0884 11.5236 29.8143C10.6443 31.5396 10.0343 33.402 9.7163 35.32C9.56141 36.2797 9.47545 37.2511 9.44431 38.2251C9.4185 39.2 9.4648 40.1753 9.53187 41.1504L9.30725 41.1262C9.9489 39.2817 10.8434 37.5332 11.9417 35.9324Z"
                fill="url(#paint7_linear_374_747)"
              />
              <path
                d="M29.2121 60.1948C26.8326 59.9763 24.4619 59.5518 22.1703 58.8343C19.8768 58.1275 17.6758 57.1002 15.6612 55.777C14.6537 55.1154 13.7028 54.3654 12.8184 53.5436C11.9383 52.717 11.1263 51.8167 10.3963 50.8538C8.93422 48.9289 7.80689 46.7538 7.04362 44.4613C6.27211 42.1694 5.88595 39.7566 5.82793 37.3452C5.77072 34.9325 6.04616 32.5125 6.66039 30.1791C7.27303 27.8478 8.23882 25.5979 9.59662 23.6011C10.9393 21.607 12.7402 19.8607 14.9395 18.8483L14.961 19.0074C14.1839 18.8661 13.3882 18.8028 12.5946 18.7535C11.7999 18.7064 11.0037 18.6737 10.2069 18.6623C11.0037 18.6426 11.8013 18.6364 12.5989 18.6588C13.3965 18.6838 14.1943 18.7219 14.9906 18.8414L15.2501 18.8802L15.0121 19.0005C13.954 19.536 12.9826 20.2335 12.1334 21.0574C11.2746 21.8715 10.5254 22.7979 9.88112 23.7906C8.57814 25.772 7.69751 28.0051 7.10403 30.2935C5.92773 34.8827 6.0749 39.8035 7.53437 44.2987C8.26676 46.5451 9.35551 48.6774 10.7737 50.5688C11.4819 51.5149 12.2707 52.4006 13.1277 53.2155C13.9814 54.0333 14.8982 54.7891 15.8773 55.4574C17.8321 56.7995 19.9909 57.8432 22.2453 58.6049C24.4949 59.3926 26.8457 59.8669 29.2121 60.1948Z"
                fill="url(#paint8_linear_374_747)"
              />
              <path
                d="M46.2088 49.2377H44.8374C44.2755 49.2377 43.8183 49.0663 43.466 48.7234C43.1136 48.371 42.9374 47.871 42.9374 47.2234V29.7234L43.1231 29.5377H44.3517C45.0183 29.5377 45.4945 29.7091 45.7802 30.052C46.066 30.3853 46.2088 30.9139 46.2088 31.6377V49.2377ZM54.3374 46.3948C54.3374 47.4805 54.166 48.2282 53.8231 48.6377C53.4898 49.0377 52.9279 49.2377 52.1374 49.2377H44.8374L43.1374 46.8377C44.0707 46.6853 45.0374 46.5758 46.0374 46.5091C47.0374 46.4329 47.9469 46.3948 48.766 46.3948H54.3374ZM60.5776 49.1948C60.1204 49.2805 59.5918 49.3234 58.9918 49.3234C58.3918 49.3234 57.8633 49.2805 57.4061 49.1948V38.8663C57.4061 38.371 57.3157 37.9996 57.1347 37.752C56.9538 37.4948 56.6252 37.3663 56.149 37.3663H55.8061C55.7204 37.0043 55.6776 36.6329 55.6776 36.252C55.6776 36.071 55.6871 35.8853 55.7061 35.6948C55.7252 35.4948 55.7585 35.2948 55.8061 35.0948C56.1776 35.0472 56.5347 35.0139 56.8776 34.9948C57.2204 34.9758 57.5014 34.9663 57.7204 34.9663H58.149C58.9014 34.9663 59.4918 35.2043 59.9204 35.6805C60.3585 36.1567 60.5776 36.8091 60.5776 37.6377V49.1948ZM56.5204 31.2234C56.5204 30.7282 56.6109 30.2853 56.7918 29.8948C56.9823 29.7901 57.2299 29.7043 57.5347 29.6377C57.849 29.5615 58.1538 29.5234 58.449 29.5234C58.7252 29.5234 59.0299 29.5615 59.3633 29.6377C59.6966 29.7043 59.9442 29.7901 60.1061 29.8948C60.1823 30.0758 60.2442 30.2901 60.2918 30.5377C60.349 30.7853 60.3776 31.0139 60.3776 31.2234C60.3776 31.7186 60.2871 32.1663 60.1061 32.5663C59.9538 32.671 59.7061 32.7567 59.3633 32.8234C59.0299 32.8901 58.7252 32.9234 58.449 32.9234C58.1538 32.9234 57.8442 32.8901 57.5204 32.8234C57.2061 32.7567 56.9633 32.671 56.7918 32.5663C56.6109 32.1663 56.5204 31.7186 56.5204 31.2234ZM63.5173 48.1663C63.5363 47.8043 63.6459 47.4091 63.8459 46.9805C64.0459 46.5424 64.2744 46.1996 64.5316 45.952C65.1411 46.2758 65.7887 46.5663 66.4744 46.8234C67.1601 47.0805 67.8506 47.2091 68.5459 47.2091C69.2887 47.2091 69.8744 47.052 70.303 46.7377C70.7411 46.4234 70.9601 46.0234 70.9601 45.5377C70.9601 45.1567 70.8173 44.8091 70.5316 44.4948C70.2459 44.171 69.8173 43.9043 69.2459 43.6948L67.5887 43.0805C66.9316 42.8424 66.3268 42.5424 65.7744 42.1805C65.2316 41.8186 64.7935 41.3758 64.4601 40.852C64.1363 40.3282 63.9744 39.7043 63.9744 38.9805C63.9744 38.0948 64.1935 37.3329 64.6316 36.6948C65.0792 36.0472 65.6887 35.552 66.4601 35.2091C67.2411 34.8567 68.1221 34.6805 69.103 34.6805C69.8935 34.6805 70.7316 34.7901 71.6173 35.0091C72.5125 35.2186 73.2554 35.4615 73.8459 35.7377C73.8649 36.1282 73.784 36.552 73.603 37.0091C73.4316 37.4663 73.2078 37.8091 72.9316 38.0377C72.4173 37.8091 71.8221 37.5948 71.1459 37.3948C70.4792 37.1853 69.7935 37.0805 69.0887 37.0805C68.5078 37.0805 68.0411 37.2234 67.6887 37.5091C67.3363 37.7948 67.1601 38.171 67.1601 38.6377C67.1601 39.0091 67.2982 39.3234 67.5744 39.5805C67.8506 39.8282 68.2697 40.0567 68.8316 40.2663L70.5887 40.9234C71.6649 41.3043 72.5411 41.8424 73.2173 42.5377C73.903 43.2329 74.2459 44.1424 74.2459 45.2663C74.2459 46.5996 73.7268 47.652 72.6887 48.4234C71.6506 49.1948 70.2744 49.5805 68.5601 49.5805C67.5506 49.5805 66.6125 49.4377 65.7459 49.152C64.8887 48.8663 64.1459 48.5377 63.5173 48.1663ZM76.0452 48.1663C76.0642 47.8043 76.1738 47.4091 76.3738 46.9805C76.5738 46.5424 76.8023 46.1996 77.0595 45.952C77.669 46.2758 78.3166 46.5663 79.0023 46.8234C79.6881 47.0805 80.3785 47.2091 81.0738 47.2091C81.8166 47.2091 82.4023 47.052 82.8309 46.7377C83.269 46.4234 83.4881 46.0234 83.4881 45.5377C83.4881 45.1567 83.3452 44.8091 83.0595 44.4948C82.7738 44.171 82.3452 43.9043 81.7738 43.6948L80.1166 43.0805C79.4595 42.8424 78.8547 42.5424 78.3023 42.1805C77.7595 41.8186 77.3214 41.3758 76.9881 40.852C76.6642 40.3282 76.5023 39.7043 76.5023 38.9805C76.5023 38.0948 76.7214 37.3329 77.1595 36.6948C77.6071 36.0472 78.2166 35.552 78.988 35.2091C79.769 34.8567 80.65 34.6805 81.6309 34.6805C82.4214 34.6805 83.2595 34.7901 84.1452 35.0091C85.0404 35.2186 85.7833 35.4615 86.3738 35.7377C86.3928 36.1282 86.3119 36.552 86.1309 37.0091C85.9595 37.4663 85.7357 37.8091 85.4595 38.0377C84.9452 37.8091 84.35 37.5948 83.6738 37.3948C83.0071 37.1853 82.3214 37.0805 81.6166 37.0805C81.0357 37.0805 80.569 37.2234 80.2166 37.5091C79.8642 37.7948 79.6881 38.171 79.6881 38.6377C79.6881 39.0091 79.8261 39.3234 80.1023 39.5805C80.3785 39.8282 80.7976 40.0567 81.3595 40.2663L83.1166 40.9234C84.1928 41.3043 85.069 41.8424 85.7452 42.5377C86.4309 43.2329 86.7738 44.1424 86.7738 45.2663C86.7738 46.5996 86.2547 47.652 85.2166 48.4234C84.1785 49.1948 82.8023 49.5805 81.0881 49.5805C80.0785 49.5805 79.1404 49.4377 78.2738 49.152C77.4166 48.8663 76.6738 48.5377 76.0452 48.1663Z"
                fill="black"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_374_747"
                  x1="16.4896"
                  y1="-1.58997"
                  x2="16.6837"
                  y2="11.2207"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF6624" />
                  <stop offset="0.1843" stop-color="#EE5E1F" />
                  <stop offset="0.5478" stop-color="#C34712" />
                  <stop offset="1" stop-color="#852800" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_374_747"
                  x1="16.5671"
                  y1="4.8299"
                  x2="16.3697"
                  y2="9.66567"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="white" />
                  <stop offset="0.495" stop-color="#EEEEEE" />
                  <stop offset="1" stop-color="#C3C3C3" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_374_747"
                  x1="18.2812"
                  y1="-0.346876"
                  x2="23.9584"
                  y2="60.6834"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF8351" />
                  <stop offset="0.595" stop-color="#EE5C1D" />
                  <stop offset="1" stop-color="#C3440B" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_374_747"
                  x1="9.73803"
                  y1="0.216183"
                  x2="15.4518"
                  y2="61.6399"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#A83400" />
                  <stop offset="0.2731" stop-color="#C3440B" />
                  <stop offset="0.7546" stop-color="#EE5C1D" />
                  <stop offset="1" stop-color="#FF6624" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_374_747"
                  x1="22.6593"
                  y1="-15.5777"
                  x2="23.6647"
                  y2="50.779"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF6624" />
                  <stop offset="0.385" stop-color="#EE5E1F" />
                  <stop offset="1" stop-color="#C34712" />
                </linearGradient>
                <linearGradient
                  id="paint5_linear_374_747"
                  x1="27.8736"
                  y1="3.67056"
                  x2="16.0311"
                  y2="61.6992"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="white" />
                  <stop offset="0.2101" stop-color="#EEEEEE" />
                  <stop offset="0.6219" stop-color="#C3C3C3" />
                  <stop offset="1" stop-color="#969696" />
                </linearGradient>
                <linearGradient
                  id="paint6_linear_374_747"
                  x1="32.2811"
                  y1="-0.758187"
                  x2="19.3528"
                  y2="50.7576"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="white" />
                  <stop offset="0.625" stop-color="#EEEEEE" />
                  <stop offset="1" stop-color="#C3C3C3" />
                </linearGradient>
                <linearGradient
                  id="paint7_linear_374_747"
                  x1="22.357"
                  y1="9.15772"
                  x2="25.3151"
                  y2="40.9569"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF6624" />
                  <stop offset="0.2454" stop-color="#EE5C1D" />
                  <stop offset="0.7269" stop-color="#C3440B" />
                  <stop offset="1" stop-color="#A83400" />
                </linearGradient>
                <linearGradient
                  id="paint8_linear_374_747"
                  x1="14.6254"
                  y1="17.9854"
                  x2="18.6674"
                  y2="61.4376"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FF6624" />
                  <stop offset="0.2454" stop-color="#EE5C1D" />
                  <stop offset="0.7269" stop-color="#C3440B" />
                  <stop offset="1" stop-color="#A83400" />
                </linearGradient>
              </defs>
            </svg>
          </div>

          <div class="title">Лотов {{ item.developer_lot }}</div>
        </div>
        <div
          :class="
            $store.state.isMobile
              ? 'search__block flex'
              : 'search__block flex justify-space-between align-center'
          "
        >
          <v-col cols="1" v-if="!$store.state.isMobile">
            <button
              class="btn-reset close__filter align-self-center"
              @click="backSwitch"
            >
              <svg
                width="80"
                height="24"
                viewBox="0 0 80 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.8101 6.70978C13.9028 6.80229 13.9763 6.91218 14.0265 7.03315C14.0767 7.15413 14.1025 7.28381 14.1025 7.41478C14.1025 7.54575 14.0767 7.67543 14.0265 7.7964C13.9763 7.91738 13.9028 8.02726 13.8101 8.11978L9.9301 11.9998L13.8101 15.8798C13.9971 16.0668 14.1021 16.3204 14.1021 16.5848C14.1021 16.8492 13.9971 17.1028 13.8101 17.2898C13.6231 17.4768 13.3695 17.5818 13.1051 17.5818C12.8407 17.5818 12.5871 17.4768 12.4001 17.2898L7.8101 12.6998C7.71739 12.6073 7.64384 12.4974 7.59366 12.3764C7.54348 12.2554 7.51765 12.1257 7.51765 11.9948C7.51765 11.8638 7.54348 11.7341 7.59366 11.6132C7.64384 11.4922 7.71739 11.3823 7.8101 11.2898L12.4001 6.69978C12.7801 6.31978 13.4201 6.31978 13.8101 6.70978Z"
                  fill="#8B9AB0"
                />
                <path
                  d="M44.1719 18H42.7656V12.8672H36.5781V18H35.1719V6.72656H36.5781V11.6016H42.7656V6.72656H44.1719V18ZM49.0938 16.8984C49.7812 16.8984 50.349 16.7005 50.7969 16.3047C51.25 15.9036 51.4766 15.401 51.4766 14.7969V14.1172L49.2734 14.2578C47.9922 14.3359 47.3516 14.7865 47.3516 15.6094C47.3516 16 47.5078 16.3125 47.8203 16.5469C48.138 16.7812 48.5625 16.8984 49.0938 16.8984ZM48.8047 18.0781C47.9505 18.0781 47.263 17.8516 46.7422 17.3984C46.2214 16.9453 45.9609 16.3464 45.9609 15.6016C45.9609 14.8776 46.2318 14.3099 46.7734 13.8984C47.3151 13.4818 48.0964 13.2422 49.1172 13.1797L51.4766 13.0391V12.3359C51.4766 11.8151 51.3099 11.4141 50.9766 11.1328C50.6432 10.8516 50.1667 10.7109 49.5469 10.7109C49.0573 10.7109 48.6432 10.8281 48.3047 11.0625C47.9714 11.2969 47.763 11.612 47.6797 12.0078H46.375C46.3958 11.2995 46.7109 10.7057 47.3203 10.2266C47.9297 9.74219 48.6771 9.5 49.5625 9.5C50.5573 9.5 51.3516 9.7474 51.9453 10.2422C52.5391 10.7318 52.8359 11.3906 52.8359 12.2188V18H51.5469V16.5391H51.5156C51.276 17.0078 50.9115 17.3828 50.4219 17.6641C49.9323 17.9401 49.3932 18.0781 48.8047 18.0781ZM57.5234 18.1406C56.6068 18.1406 55.8438 17.9323 55.2344 17.5156C54.6302 17.099 54.2917 16.5417 54.2188 15.8438H55.6016C55.6849 16.2135 55.8932 16.5 56.2266 16.7031C56.5651 16.9062 56.9974 17.0078 57.5234 17.0078C58.1328 17.0078 58.6068 16.8776 58.9453 16.6172C59.2839 16.3568 59.4531 16.013 59.4531 15.5859C59.4531 15.1068 59.2943 14.7552 58.9766 14.5312C58.6589 14.3021 58.1745 14.1875 57.5234 14.1875H56.25V13.0625H57.5234C58.6224 13.0625 59.1719 12.6432 59.1719 11.8047C59.1719 11.4297 59.0365 11.1302 58.7656 10.9062C58.4948 10.6823 58.0938 10.5703 57.5625 10.5703C57.0573 10.5703 56.6406 10.6719 56.3125 10.875C55.9844 11.0781 55.7917 11.349 55.7344 11.6875H54.4062C54.4948 10.9948 54.8229 10.4453 55.3906 10.0391C55.9583 9.63281 56.6823 9.42969 57.5625 9.42969C58.4948 9.42969 59.2161 9.63802 59.7266 10.0547C60.2422 10.4661 60.5 11.0156 60.5 11.7031C60.5 12.1406 60.3698 12.5286 60.1094 12.8672C59.8542 13.2057 59.5156 13.4245 59.0938 13.5234V13.5859C59.6458 13.7057 60.0651 13.9349 60.3516 14.2734C60.6432 14.6068 60.7891 15.0208 60.7891 15.5156C60.7891 16.2969 60.4896 16.9297 59.8906 17.4141C59.2917 17.8984 58.5026 18.1406 57.5234 18.1406ZM65.1719 16.8984C65.8594 16.8984 66.4271 16.7005 66.875 16.3047C67.3281 15.9036 67.5547 15.401 67.5547 14.7969V14.1172L65.3516 14.2578C64.0703 14.3359 63.4297 14.7865 63.4297 15.6094C63.4297 16 63.5859 16.3125 63.8984 16.5469C64.2161 16.7812 64.6406 16.8984 65.1719 16.8984ZM64.8828 18.0781C64.0286 18.0781 63.3411 17.8516 62.8203 17.3984C62.2995 16.9453 62.0391 16.3464 62.0391 15.6016C62.0391 14.8776 62.3099 14.3099 62.8516 13.8984C63.3932 13.4818 64.1745 13.2422 65.1953 13.1797L67.5547 13.0391V12.3359C67.5547 11.8151 67.388 11.4141 67.0547 11.1328C66.7214 10.8516 66.2448 10.7109 65.625 10.7109C65.1354 10.7109 64.7214 10.8281 64.3828 11.0625C64.0495 11.2969 63.8411 11.612 63.7578 12.0078H62.4531C62.474 11.2995 62.7891 10.7057 63.3984 10.2266C64.0078 9.74219 64.7552 9.5 65.6406 9.5C66.6354 9.5 67.4297 9.7474 68.0234 10.2422C68.6172 10.7318 68.9141 11.3906 68.9141 12.2188V18H67.625V16.5391H67.5938C67.3542 17.0078 66.9896 17.3828 66.5 17.6641C66.0104 17.9401 65.4714 18.0781 64.8828 18.0781ZM76.4141 16.875V10.7031H73.2188L72.9531 14.3047C72.8646 15.487 72.6328 16.3229 72.2578 16.8125V16.875H76.4141ZM71.25 20.2266H69.9844V16.875H70.6875C70.9792 16.6823 71.2083 16.3542 71.375 15.8906C71.5417 15.4219 71.6458 14.8828 71.6875 14.2734L72.0156 9.57812H77.7578V16.875H79.1016V20.2266H77.8359V18H71.25V20.2266Z"
                  fill="#8B9AB0"
                />
              </svg>
            </button>
          </v-col>
          <div v-if="$store.state.isMobile" class="search flex">
            <v-text-field
              clearable
              class="mr-2"
              v-model="search"
              label="Поиск"
              variant="outlined"
              hide-details
              @input="searchItems(search)"
              @click:clear="clearSearch"
            ></v-text-field>
            <v-dialog
              z-index="10"
              v-model="filterMenu"
              transition="dialog-right-transition"
              scrollable
              fullscreen
              persistent
            >
              <template v-slot:activator="{ props: activatorProps }">
                <v-btn
                  v-if="$store.state.isMobile"
                  height="56px"
                  class="text-none"
                  style="border-radius: 12px"
                  color="#FF8351"
                  prepend-icon="mdi-filter-variant"
                  variant="flat"
                  v-bind="activatorProps"
                >
                  Фильтр
                </v-btn>
              </template>
              <div class="filter__row">
                <v-card
                  height="100vh"
                  class="pa-4 pt-12"
                  tile
                  v-touch="{
                    right: () => swipe(),
                  }"
                >
                  <v-row
                    v-if="$store.state.isMobile"
                    class="align-center mb-16"
                  >
                    <v-col>
                      <button class="btn-reset close__filter" @click="swipe()">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17 10C17 10.1989 16.921 10.3897 16.7803 10.5303C16.6397 10.671 16.4489 10.75 16.25 10.75L5.61201 10.75L9.77001 14.71C9.9064 14.8494 9.98312 15.0365 9.9839 15.2315C9.98467 15.4266 9.90943 15.6142 9.77414 15.7547C9.63885 15.8952 9.45416 15.9775 9.25923 15.9841C9.0643 15.9907 8.87447 15.921 8.73001 15.79L3.23001 10.54C3.15742 10.47 3.09968 10.3862 3.06025 10.2934C3.02081 10.2006 3.00049 10.1008 3.00049 10C3.00049 9.89919 3.02081 9.79941 3.06025 9.70663C3.09968 9.61385 3.15742 9.52997 3.23001 9.46001L8.73001 4.21001C8.8002 4.13826 8.88408 4.08133 8.97668 4.04259C9.06928 4.00386 9.16871 3.9841 9.26908 3.9845C9.36945 3.9849 9.46873 4.00544 9.56101 4.04491C9.6533 4.08437 9.73673 4.14196 9.80635 4.21426C9.87598 4.28657 9.93038 4.37211 9.96634 4.46582C10.0023 4.55953 10.0191 4.65951 10.0157 4.75982C10.0123 4.86014 9.98881 4.95875 9.9466 5.04983C9.9044 5.1409 9.84435 5.22257 9.77001 5.29001L5.61201 9.25001L16.25 9.25001C16.4489 9.25001 16.6397 9.32902 16.7803 9.46968C16.921 9.61033 17 9.80109 17 10Z"
                            fill="black"
                          />
                        </svg>
                      </button>
                    </v-col>
                    <v-col>
                      <h2>Фильтр</h2>
                    </v-col>
                    <v-col>
                      <v-btn color="#FF8351" variant="text" @click="reset">
                        Сбросить
                      </v-btn>
                    </v-col>
                  </v-row>
                  <div
                    class="filter__fields flex column align-center justify-space-between"
                    style="height: 80vh"
                  >
                    <div class="form">
                      <h2 class="mb-4">Комнаты</h2>
                      <div>
                        <v-btn
                          elevation="0"
                          icon="mdi-numeric-1"
                          class="rounded-circle mr-3 mb-3"
                          :disabled="loading"
                          @click="
                            this.$store.state.filterOptions.rooms.one =
                              !this.$store.state.filterOptions.rooms.one
                          "
                          :color="
                            this.$store.state.filterOptions.rooms.one
                              ? '#FF8351'
                              : '#F4F6F9'
                          "
                          >1</v-btn
                        >
                        <v-btn
                          elevation="0"
                          icon="mdi-numeric-2"
                          class="rounded-circle mr-3 mb-3"
                          :disabled="loading"
                          @click="
                            this.$store.state.filterOptions.rooms.two =
                              !this.$store.state.filterOptions.rooms.two
                          "
                          :color="
                            this.$store.state.filterOptions.rooms.two
                              ? '#FF8351'
                              : '#F4F6F9'
                          "
                          >2</v-btn
                        >
                        <v-btn
                          elevation="0"
                          icon="mdi-numeric-3"
                          class="rounded-circle mr-3 mb-3"
                          :disabled="loading"
                          @click="
                            this.$store.state.filterOptions.rooms.three =
                              !this.$store.state.filterOptions.rooms.three
                          "
                          :color="
                            this.$store.state.filterOptions.rooms.three
                              ? '#FF8351'
                              : '#F4F6F9'
                          "
                          >3</v-btn
                        >
                        <v-btn
                          elevation="0"
                          icon="mdi-numeric-4"
                          class="rounded-circle mr-3 mb-3"
                          :disabled="loading"
                          @click="
                            this.$store.state.filterOptions.rooms.four =
                              !this.$store.state.filterOptions.rooms.four
                          "
                          :color="
                            this.$store.state.filterOptions.rooms.four
                              ? '#FF8351'
                              : '#F4F6F9'
                          "
                          >4</v-btn
                        >
                        <v-btn
                          elevation="0"
                          icon="mdi-numeric-5"
                          class="rounded-circle mr-3 mb-3"
                          :disabled="loading"
                          @click="
                            this.$store.state.filterOptions.rooms.five =
                              !this.$store.state.filterOptions.rooms.five
                          "
                          :color="
                            this.$store.state.filterOptions.rooms.five
                              ? '#FF8351'
                              : '#F4F6F9'
                          "
                          >5</v-btn
                        >
                        <v-btn
                          elevation="0"
                          icon="mdi-numeric-6"
                          class="rounded-circle mr-3 mb-3"
                          :disabled="loading"
                          @click="
                            this.$store.state.filterOptions.rooms.six =
                              !this.$store.state.filterOptions.rooms.six
                          "
                          :color="
                            this.$store.state.filterOptions.rooms.six
                              ? '#FF8351'
                              : '#F4F6F9'
                          "
                          >6+</v-btn
                        >
                      </div>
                      <div
                        :class="
                          $store.state.isMobile
                            ? 'filter__price mb-6'
                            : 'flex mb-4 justify-space-between'
                        "
                      >
                        <h2 class="mb-4">Цена</h2>
                        <div :style="!$store.state.isMobile ? 'width:75%' : ''">
                          <v-text-field
                            v-model="this.$store.state.filterOptions.price"
                            :disabled="loading"
                            variant="outlined"
                            label="За всё"
                            width="100%"
                            hide-details
                            @click="priceModal = !priceModal"
                            color="#FF8351"
                          ></v-text-field>
                          <v-dialog
                            v-model="priceModal"
                            :width="$store.state.isMobile ? '100%' : '30%'"
                            :height="$store.state.isMobile ? '' : '80%'"
                            class="price__modal"
                          >
                            <v-card class="price__modal__card pa-6 rounded-xl">
                              <div class="price__modal__header flex mb-5">
                                <h2 style="align-self: center">Цена</h2>
                                <div class="flex">
                                  <v-btn
                                    class="rounded-circle mr-3"
                                    elevation="0"
                                    icon="mdi-numeric-1"
                                    @click="
                                      this.$store.state.filterOptions.currency =
                                        '₽'
                                    "
                                    :color="
                                      this.$store.state.filterOptions
                                        .currency == '₽'
                                        ? '#FF8351'
                                        : '#F4F6F9'
                                    "
                                    >₽</v-btn
                                  >
                                  <v-btn
                                    class="rounded-circle mr-3"
                                    elevation="0"
                                    icon="mdi-numeric-1"
                                    @click="
                                      this.$store.state.filterOptions.currency =
                                        '$'
                                    "
                                    :color="
                                      this.$store.state.filterOptions
                                        .currency == '$'
                                        ? '#FF8351'
                                        : '#F4F6F9'
                                    "
                                    >$</v-btn
                                  >
                                  <v-btn
                                    class="rounded-circle mr-3"
                                    elevation="0"
                                    icon="mdi-numeric-1"
                                    @click="
                                      this.$store.state.filterOptions.currency =
                                        '€'
                                    "
                                    :color="
                                      this.$store.state.filterOptions
                                        .currency == '€'
                                        ? '#FF8351'
                                        : '#F4F6F9'
                                    "
                                    >€</v-btn
                                  >
                                </div>
                              </div>
                              <div
                                class="price__modal__type mb-5 rounded-xl pa-2 flex"
                              >
                                <v-btn
                                  width="49%"
                                  :color="
                                    this.$store.state.filterOptions.priceType
                                      ? '#474849'
                                      : '#f4f6f9'
                                  "
                                  class="rounded-xl"
                                  elevation="0"
                                  @click="
                                    this.$store.state.filterOptions.priceType = true
                                  "
                                  >За все</v-btn
                                >
                                <v-btn
                                  width="49%"
                                  class="rounded-xl"
                                  elevation="0"
                                  :color="
                                    !this.$store.state.filterOptions.priceType
                                      ? '#474849'
                                      : '#f4f6f9'
                                  "
                                  @click="
                                    this.$store.state.filterOptions.priceType = false
                                  "
                                  >За метр</v-btn
                                >
                              </div>
                              <div class="price__modal__form mb-5">
                                <v-text-field
                                  class="mb-3"
                                  v-model="
                                    this.$store.state.filterOptions.priceFrom
                                  "
                                  clearable
                                  color="#FF8351"
                                  label="от"
                                  variant="outlined"
                                  hide-details
                                ></v-text-field>
                                <v-text-field
                                  v-model="
                                    this.$store.state.filterOptions.priceTo
                                  "
                                  clearable
                                  color="#FF8351"
                                  label="до"
                                  variant="outlined"
                                  hide-details
                                ></v-text-field>
                              </div>
                              <div
                                class="price__modal__actions flex justify-end"
                              >
                                <v-btn
                                  variant="text"
                                  @click="priceModal = false"
                                  >Отмена</v-btn
                                >
                                <v-btn
                                  variant="text"
                                  color="#FF8351"
                                  @click="getPriceFilter"
                                  >Ок</v-btn
                                >
                              </div>
                            </v-card>
                          </v-dialog>
                        </div>
                      </div>
                      <div
                        :class="
                          $store.state.isMobile
                            ? 'filter__square mb-6'
                            : 'flex justify-space-between mb-4'
                        "
                      >
                        <h2 class="mb-4">Площадь, м²</h2>
                        <div :style="!$store.state.isMobile ? 'width:75%' : ''">
                          <v-text-field
                            v-model="this.$store.state.filterOptions.square"
                            :disabled="loading"
                            variant="outlined"
                            label="Общая,  м²"
                            hide-details
                            @click="squareModal = !squareModal"
                            color="#FF8351"
                          ></v-text-field>
                          <v-dialog
                            v-model="squareModal"
                            :width="$store.state.isMobile ? '100%' : '30%'"
                            :height="$store.state.isMobile ? '' : '80%'"
                            class="price__modal align-center"
                          >
                            <v-card class="square__modal__card pa-6 rounded-xl">
                              <div class="price__modal__header flex mb-5">
                                <h2 style="align-self: center">Площадь</h2>
                              </div>
                              <div class="square__modal__form mb-5">
                                <v-text-field
                                  class="mb-3"
                                  v-model="
                                    this.$store.state.filterOptions.squareFrom
                                  "
                                  clearable
                                  color="#FF8351"
                                  label="от"
                                  variant="outlined"
                                  hide-details
                                ></v-text-field>
                                <v-text-field
                                  v-model="
                                    this.$store.state.filterOptions.squareTo
                                  "
                                  clearable
                                  color="#FF8351"
                                  label="до"
                                  variant="outlined"
                                  hide-details
                                ></v-text-field>
                              </div>
                              <div
                                class="square__modal__actions flex justify-end"
                              >
                                <v-btn
                                  variant="text"
                                  @click="squareModal = false"
                                  >Отмена</v-btn
                                >
                                <v-btn
                                  variant="text"
                                  color="#FF8351"
                                  @click="getSquareFilter"
                                  >Ок</v-btn
                                >
                              </div>
                            </v-card>
                          </v-dialog>
                        </div>
                      </div>
                    </div>

                    <div class="actions flex column">
                      <div class="filter__text text-center">
                        <p>
                          Чтобы ознакомиться с нашими объектами, необходимо
                          настроить фильтр под ваши требования
                        </p>
                      </div>
                      <v-btn
                        color="#ff8351"
                        elevation="0"
                        min-height="54px"
                        style="border-radius: 12px"
                        :disabled="loading"
                        :loading="loading"
                        @click="getFilterItems"
                        >Показать объекты</v-btn
                      >
                    </div>
                  </div>
                </v-card>
              </div>
            </v-dialog>
          </div>
        </div>
      </div>
      <div class="filter__row" v-if="!$store.state.isMobile">
        <v-sheet border rounded="xl" class="pa-4">
          <div class="filter__row flex">
            <div class="rooms_block flex pl-4 mr-2">
              <p class="mr-2" style="color: #a1a7b0">Комнаты</p>
              <v-btn
                elevation="0"
                icon="mdi-numeric-1"
                class="rounded-circle mr-1"
                :disabled="loading"
                @click="
                  this.$store.state.filterOptions.rooms.one =
                    !this.$store.state.filterOptions.rooms.one
                "
                :color="
                  this.$store.state.filterOptions.rooms.one ? '#FF8351' : '#fff'
                "
                >1</v-btn
              >
              <v-btn
                elevation="0"
                icon="mdi-numeric-2"
                class="rounded-circle mr-1"
                :disabled="loading"
                @click="
                  this.$store.state.filterOptions.rooms.two =
                    !this.$store.state.filterOptions.rooms.two
                "
                :color="
                  this.$store.state.filterOptions.rooms.two ? '#FF8351' : '#fff'
                "
                >2</v-btn
              >
              <v-btn
                elevation="0"
                icon="mdi-numeric-3"
                class="rounded-circle mr-1"
                :disabled="loading"
                @click="
                  this.$store.state.filterOptions.rooms.three =
                    !this.$store.state.filterOptions.rooms.three
                "
                :color="
                  this.$store.state.filterOptions.rooms.three
                    ? '#FF8351'
                    : '#fff'
                "
                >3</v-btn
              >
              <v-btn
                elevation="0"
                icon="mdi-numeric-4"
                class="rounded-circle mr-1"
                :disabled="loading"
                @click="
                  this.$store.state.filterOptions.rooms.four =
                    !this.$store.state.filterOptions.rooms.four
                "
                :color="
                  this.$store.state.filterOptions.rooms.four
                    ? '#FF8351'
                    : '#fff'
                "
                >4</v-btn
              >
              <v-btn
                elevation="0"
                icon="mdi-numeric-5"
                class="rounded-circle mr-1"
                :disabled="loading"
                @click="
                  this.$store.state.filterOptions.rooms.five =
                    !this.$store.state.filterOptions.rooms.five
                "
                :color="
                  this.$store.state.filterOptions.rooms.five
                    ? '#FF8351'
                    : '#fff'
                "
                >5</v-btn
              >
              <v-btn
                elevation="0"
                icon="mdi-numeric-6"
                class="rounded-circle mr-1"
                :disabled="loading"
                @click="
                  this.$store.state.filterOptions.rooms.six =
                    !this.$store.state.filterOptions.rooms.six
                "
                :color="
                  this.$store.state.filterOptions.rooms.six ? '#FF8351' : '#fff'
                "
                >6+</v-btn
              >
            </div>
            <div class="filter__price mr-2">
              <v-text-field
                v-model="this.$store.state.filterOptions.price"
                :disabled="loading"
                variant="outlined"
                label="Цена"
                min-width="230"
                hide-details
                @click="priceModal = !priceModal"
                color="#FF8351"
              ></v-text-field>
              <v-dialog v-model="priceModal" width="30%" class="price__modal">
                <v-card class="price__modal__card pa-6 rounded-xl">
                  <div class="price__modal__header flex mb-5">
                    <h2 class="mr-2" style="align-self: center">Цена</h2>
                    <div class="flex">
                      <v-btn
                        class="rounded-circle mr-3"
                        elevation="0"
                        icon="mdi-numeric-1"
                        @click="this.$store.state.filterOptions.currency = '₽'"
                        :color="
                          this.$store.state.filterOptions.currency == '₽'
                            ? '#FF8351'
                            : '#F4F6F9'
                        "
                        >₽</v-btn
                      >
                      <v-btn
                        class="rounded-circle mr-3"
                        elevation="0"
                        icon="mdi-numeric-1"
                        @click="this.$store.state.filterOptions.currency = '$'"
                        :color="
                          this.$store.state.filterOptions.currency == '$'
                            ? '#FF8351'
                            : '#F4F6F9'
                        "
                        >$</v-btn
                      >
                      <v-btn
                        class="rounded-circle mr-3"
                        elevation="0"
                        icon="mdi-numeric-1"
                        @click="this.$store.state.filterOptions.currency = '€'"
                        :color="
                          this.$store.state.filterOptions.currency == '€'
                            ? '#FF8351'
                            : '#F4F6F9'
                        "
                        >€</v-btn
                      >
                    </div>
                  </div>
                  <div class="price__modal__type mb-5 rounded-xl pa-2 flex">
                    <v-btn
                      width="49%"
                      :color="
                        this.$store.state.filterOptions.priceType
                          ? '#474849'
                          : '#f4f6f9'
                      "
                      class="rounded-xl"
                      elevation="0"
                      @click="this.$store.state.filterOptions.priceType = true"
                      >За все</v-btn
                    >
                    <v-btn
                      width="49%"
                      class="rounded-xl"
                      elevation="0"
                      :color="
                        !this.$store.state.filterOptions.priceType
                          ? '#474849'
                          : '#f4f6f9'
                      "
                      @click="this.$store.state.filterOptions.priceType = false"
                      >За метр</v-btn
                    >
                  </div>
                  <div class="price__modal__form mb-5">
                    <v-text-field
                      class="mb-3"
                      v-model="this.$store.state.filterOptions.priceFrom"
                      clearable
                      color="#FF8351"
                      label="от"
                      variant="outlined"
                      hide-details
                    ></v-text-field>
                    <v-text-field
                      v-model="this.$store.state.filterOptions.priceTo"
                      clearable
                      color="#FF8351"
                      label="до"
                      variant="outlined"
                      hide-details
                    ></v-text-field>
                  </div>
                  <div class="price__modal__actions flex justify-end">
                    <v-btn variant="text" @click="priceModal = false"
                      >Отмена</v-btn
                    >
                    <v-btn
                      variant="text"
                      color="#FF8351"
                      @click="getPriceFilter"
                      >Ок</v-btn
                    >
                  </div>
                </v-card>
              </v-dialog>
            </div>
            <div class="filter__price mr-2">
              <v-text-field
                v-model="this.$store.state.filterOptions.square"
                :disabled="loading"
                variant="outlined"
                min-width="230"
                label="Общая,  м²"
                hide-details
                @click="squareModal = !squareModal"
                color="#FF8351"
              ></v-text-field>
              <v-dialog
                v-model="squareModal"
                :width="$store.state.isMobile ? '100%' : '30%'"
                :height="$store.state.isMobile ? '' : '80%'"
                class="price__modal align-center"
              >
                <v-card class="square__modal__card pa-6 rounded-xl">
                  <div class="price__modal__header flex mb-5">
                    <h2 style="align-self: center">Площадь</h2>
                  </div>
                  <div class="square__modal__form mb-5">
                    <v-text-field
                      class="mb-3"
                      v-model="this.$store.state.filterOptions.squareFrom"
                      clearable
                      color="#FF8351"
                      label="от"
                      variant="outlined"
                      hide-details
                    ></v-text-field>
                    <v-text-field
                      v-model="this.$store.state.filterOptions.squareTo"
                      clearable
                      color="#FF8351"
                      label="до"
                      variant="outlined"
                      hide-details
                    ></v-text-field>
                  </div>
                  <div class="square__modal__actions flex justify-end">
                    <v-btn variant="text" @click="squareModal = false"
                      >Отмена</v-btn
                    >
                    <v-btn
                      variant="text"
                      color="#FF8351"
                      @click="getSquareFilter"
                      >Ок</v-btn
                    >
                  </div>
                </v-card>
              </v-dialog>
            </div>

            <div class="search__desctop mr-2">
              <v-text-field
                clearable
                v-model="search"
                label="Поиск"
                color="#FF8351"
                variant="outlined"
                hide-details
                min-width="250"
                @input="searchItems(search)"
                @click:clear="clearSearch"
              ></v-text-field>
            </div>

            <v-btn
              color="#ff8351"
              elevation="0"
              min-height="54px"
              style="border-radius: 12px"
              :disabled="loading"
              :loading="loading"
              @click="getFilterItems"
              >Показать</v-btn
            >
            <v-btn color="#FF8351" variant="text" @click="reset">
              Сбросить
            </v-btn>
          </div>
        </v-sheet>
      </div>
      <div
        class="sort__block mb-2 flex justify-space-between align-center"
        v-if="$store.state.isMobile"
      >
        <p>
          Сортировка: <b @click="sortMenu = !sortMenu">{{ sortType.name }}</b>
        </p>
        <v-btn
          v-if="$store.state.isMobile"
          height=""
          class="text-none"
          style="border-radius: 12px"
          color="#FF8351"
          prepend-icon="mdi-format-list-text"
          variant="flat"
          @click="сhangeList()"
        >
          {{ typeItems }}
        </v-btn>
      </div>
      <SortMenu
        v-else
        @сhangeList="сhangeList()"
        @sortItems="sortItems"
        v-model="sortType"
        v-model:typeItems="typeItems"
        v-model:isList="isList"
      ></SortMenu>
      <div class="map"></div>
      <div
        :class="
          $store.state.isMobile || isList
            ? 'items__block__list flex'
            : 'flex items__block__list__cards'
        "
      >
        <div
          style="width: 345px; margin-right: 10px"
          :class="$store.state.isMobile || isList ? 'item' : 'item__cards'"
          v-for="item in filterItems"
          :key="item.id"
        >
          <v-dialog
            v-model="item.dialog"
            transition="dialog-right-transition"
            fullscreen
          >
            <template v-slot:activator="{ props: activatorProps }">
              <CardItem
                v-if="!isList"
                :item="item"
                v-model="item.selected"
                v-bind="activatorProps"
              ></CardItem>
              <CardListItem
                v-else
                :item="item"
                v-model:="item.selected"
                v-bind="activatorProps"
              ></CardListItem>
            </template>
            <CardWiev
              :item="item"
              v-model:modal="item.dialog"
              v-model:select="item.selected"
            ></CardWiev>
          </v-dialog>
        </div>
      </div>
      <v-bottom-sheet v-model="options">
        <v-list class="rounded-t-xl" height="250">
          <v-list-subheader>Действия</v-list-subheader>
          <v-list-item
            :title="`Создать PDF`"
            :disabled="loading"
            :loading="loading"
            @click="presentationAdd('enable')"
          >
            <template v-slot:prepend>
              <v-icon icon="mdi-view-list-outline"></v-icon>
            </template>
          </v-list-item>
          <v-list-item
            title="Cбросить подборку"
            :disabled="loading"
            :loading="loading"
            @click="deleteSelectItems"
          >
            <template v-slot:prepend>
              <v-icon icon="mdi-trash-can-outline"></v-icon>
            </template>
          </v-list-item>
        </v-list>
      </v-bottom-sheet>
      <v-bottom-sheet v-model="sortMenu">
        <v-list class="rounded-t-xl" height="320">
          <v-list-subheader>Действия</v-list-subheader>
          <v-list-item
            v-for="sortItem in sortTypes"
            :key="sortItem.id"
            :title="sortItem.name"
            @click="sortItems(sortItem)"
          >
          </v-list-item>
        </v-list>
      </v-bottom-sheet>
      <v-snackbar
        v-model="isPress"
        color="white"
        min-width="104%"
        v-if="$store.state.isMobile"
      >
        <v-btn
          class="presentation__btn text-none mr-5"
          height="100%"
          width="75%"
          style="border-radius: 35px; padding: 25px; font-size: 16px"
          color="#FF8351"
          variant="flat"
          :disabled="loading"
          :loading="loading"
          @click="addSelection"
          >{{
            `Создать подборку (${this.$store.state.selectItems.length})`
          }}</v-btn
        >
        <v-btn
          class="rounded-circle mx-auto"
          style="height: 64px"
          @click="options = !options"
        >
          <svg
            width="16"
            height="4"
            viewBox="0 0 16 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.96484 3.61816C1.09473 3.61816 0.417969 2.94141 0.417969 2.07129C0.417969 1.20117 1.09473 0.524414 1.96484 0.524414C2.82422 0.524414 3.50098 1.20117 3.50098 2.07129C3.50098 2.94141 2.82422 3.61816 1.96484 3.61816ZM7.89453 3.61816C7.02441 3.61816 6.34766 2.94141 6.34766 2.07129C6.34766 1.20117 7.02441 0.524414 7.89453 0.524414C8.75391 0.524414 9.43066 1.20117 9.43066 2.07129C9.43066 2.94141 8.75391 3.61816 7.89453 3.61816ZM13.8242 3.61816C12.9541 3.61816 12.2773 2.94141 12.2773 2.07129C12.2773 1.20117 12.9541 0.524414 13.8242 0.524414C14.6836 0.524414 15.3604 1.20117 15.3604 2.07129C15.3604 2.94141 14.6836 3.61816 13.8242 3.61816Z"
              fill="#474849"
            />
          </svg>
        </v-btn>
      </v-snackbar>
      <v-snackbar
        v-model="isPress"
        color="white"
        min-width="100%"
        v-else
        class="ma-0"
      >
        <div class="flex justify-space-between">
          <v-btn
            class="presentation__btn text-none"
            height="100%"
            style="padding: 15px; font-size: 16px"
            rounded="lg"
            color="#FF8351"
            variant="flat"
            :disabled="loading"
            :loading="loading"
            @click="addSelection"
            >{{
              `Создать подборку (${this.$store.state.selectItems.length})`
            }}</v-btn
          >
          <div>
            <v-btn
              class="presentation__btn text-none mr-4"
              height="100%"
              style="padding: 15px; font-size: 16px"
              rounded="lg"
              color="#FF8351"
              variant="outlined"
              :disabled="loading"
              :loading="loading"
              @click="presentationAdd('enable')"
              >{{
                `Создать PDF (${this.$store.state.selectItems.length})`
              }}</v-btn
            >
            <v-btn
              class="presentation__btn text-none"
              height="100%"
              style="padding: 15px; font-size: 16px"
              rounded="lg"
              color="#FF8351"
              variant="outlined"
              :disabled="loading"
              :loading="loading"
              @click="deleteSelectItems"
              >{{
                `Сбросить подборку (${this.$store.state.selectItems.length})`
              }}</v-btn
            >
          </div>
        </div>
      </v-snackbar>
    </div>
  </v-card>
</template>

<script>
import CardItem from "../home/CardItem.vue";
import CardListItem from "../home/CardListItem.vue";
import CardWiev from "../home/CardWiev.vue";
import axios from "axios";
import copy from "copy-to-clipboard";
import SortMenu from "../SortMenu.vue";

export default {
  name: "ItemPage",
  components: {
    CardItem,
    CardListItem,
    CardWiev,
    SortMenu,
  },
  props: {
    item: Object,
    modelValue: Boolean,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      items: [],
      squareModal: false,
      priceModal: false,
      loading: false,
      isUrlCopy: false,
      urlCopy: "",
      valueNav: "",
      search: "",
      typeItems: "Карточки",
      sortType: { id: 3, name: "Cначала новые" },
      sortMenu: false,
      filterMenu: false,
      options: false,
      isMap: false,
      isList: true,
      sortTypes: [
        { id: 1, name: "Cначала новые" },
        { id: 2, name: "Cначала старые" },
        { id: 3, name: "Cначала дешевые" },
        { id: 4, name: "Cначала дорогие" },
      ],
      filterItems: [],
    };
  },
  methods: {
    reset() {
      const filterOptions = {
        priceType: true,
        isHouse: false,
        isPlot: false,
        isApart: false,
        isSecondary: false,
        isNewBuild: false,
        isTerrace: false,
        isTownHouse: false,
        isWhitebox: false,
        isNotOtc: false,
        isOtc: false,
        rooms: {
          one: false,
          two: false,
          three: false,
          four: false,
          five: false,
          six: false,
        },
        price: "",
        priceTo: "",
        priceFrom: "",
        square: "",
        statusObj: [],
        selectStatus: "",
        currency: "₽",
        city: [],
        district: [],
        streets: [],
        metro: [],
      };
      this.$store.commit("filterOptionUpdate", filterOptions);
    },
    async getItems() {
      try {
        const items = [];
        const itemsData = await axios.get(
          "https://lissearch.ru/backend/api/api.php",
          { params: { params: "getLot", jk_id: this.item.id } }
        );
        for (const objItem of itemsData.data) {
          objItem.jk_name = this.item.jk_name;
          objItem.lot_name = objItem.lot_name
            .split("Продается")[1]
            .split(",")[0]
            .replace("омн.", "");
          objItem.dialog = false;
          objItem.selected = false;
          objItem.cian = false;
          objItem.coordinates = [objItem.lon, objItem.lat];
          //--------------------------
          objItem.fullPricexls = Number(objItem.lot_price);
          objItem.fullPrice = new Intl.NumberFormat("ru-RU").format(
            Number(objItem.lot_price)
          );
          objItem.squarePriceXls = Number(objItem.lot_price_m2);
          objItem.squarePrice = new Intl.NumberFormat("ru-RU").format(
            Number(objItem.squarePriceXls)
          );
          objItem.comission = objItem.comission ? objItem.comission : "3%";
          objItem.assigned = {
            name: "Фамилия Имя Отчество",
            position: "Должность",
            avatar:
              "https://img.freepik.com/free-photo/front-view-of-smiley-man-outdoors-in-the-city_23-2148955558.jpg",
            phone: "",
            email: "",
          };
          objItem.wc = objItem.wc ? objItem.wc : "0";
          objItem.lot_bedroom = objItem.lot_bedroom ? objItem.lot_bedroom : "0";
          objItem.currency = objItem.currency ? objItem.currency : "₽";
          objItem.status = "Новостройка";
          objItem.type = "Продажа";
          objItem.photos = objItem.lot_photo_url.split(";");
          items.push(objItem);
        }
        this.items = items;
        this.filterItems = this.items;
        this.$store.commit("itemsAdd", [this.item.id, this.items]);
      } catch (e) {
        console.log(e);
      }
    },
    async getFilterItems() {
      try {
        this.loading = true;
        const items = [];
        const itemsData = await axios.get(
          "https://lissearch.ru/backend/api/api.php",
          {
            params: {
              params: "filterlot",
              residence: this.item.id,
              filterLot: this.$store.state.filterOptions,
            },
          }
        );
        console.log({ itemsData });
        for (const objItem of itemsData.data) {
          objItem.jk_name = this.item.jk_name;
          objItem.lot_name = objItem.lot_name
            .split("Продается")[1]
            .split(",")[0]
            .replace("омн.", "");
          objItem.dialog = false;
          objItem.selected = false;
          objItem.cian = false;
          objItem.coordinates = [objItem.lon, objItem.lat];
          //--------------------------
          objItem.fullPricexls = Number(objItem.lot_price);
          objItem.fullPrice = new Intl.NumberFormat("ru-RU").format(
            Number(objItem.lot_price)
          );
          objItem.squarePriceXls = Number(objItem.lot_price_m2);
          objItem.squarePrice = new Intl.NumberFormat("ru-RU").format(
            Number(objItem.squarePriceXls)
          );
          objItem.comission = objItem.comission ? objItem.comission : "3%";
          objItem.assigned = {
            name: "Фамилия Имя Отчество",
            position: "Должность",
            avatar:
              "https://img.freepik.com/free-photo/front-view-of-smiley-man-outdoors-in-the-city_23-2148955558.jpg",
            phone: "",
            email: "",
          };
          objItem.wc = objItem.wc ? objItem.wc : "0";
          objItem.lot_bedroom = objItem.lot_bedroom ? objItem.lot_bedroom : "0";
          objItem.currency = objItem.currency ? objItem.currency : "₽";
          objItem.status = "Новостройка";
          objItem.type = "Продажа";
          objItem.photos = objItem.lot_photo_url.split(";");
          items.push(objItem);
        }
        this.items = items;
        this.filterItems = this.items;
        this.$store.commit("itemsAdd", [this.item.id, this.items]);
        this.loading = false;
        this.filterMenu = false;
      } catch (e) {
        console.log(e);
      }
    },
    getPriceFilter() {
      const filterOptions = this.$store.state.filterOptions;
      // console.log({ filterOptions });
      filterOptions.price = `${filterOptions.currency} ${filterOptions.priceFrom} - ${filterOptions.priceTo}`;
      this.$store.commit("filterOptionUpdate", filterOptions);

      this.priceModal = false;
    },
    getSquareFilter() {
      const filterOptions = this.$store.state.filterOptions;
      filterOptions.square = `${filterOptions.squareFrom} м² - ${filterOptions.squareTo} м²`;
      this.$store.commit("filterOptionUpdate", filterOptions);
      this.squareModal = false;
    },
    backSwitch() {
      this.$emit("update:modelValue", false);
    },
    swipe() {
      this.filterMenu = false;
    },
    clearSearch() {
      this.filterItems = this.item.items;
    },
    searchItems(search) {
      if (search) {
        if (search.length > 0) {
          console.log(search, "search");
          this.filterItems = this.item.items.filter((item) => {
            return (
              //название, адрес, сумма,
              item.lot_name.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
              item.lot_price.toLowerCase().indexOf(search.toLowerCase()) > -1
            );
          });
          console.log(this.filterItems);
        } else {
          this.filterItems = this.item.items;
        }
      }
    },
    sortItems(item) {
      try {
        this.sortType = item;
        switch (item.id) {
          case 1:
            console.log(item.id, "1");
            this.filterItems.sort((a, b) => {
              return Number(a.id) - Number(b.id);
            });
            break;
          case 2:
            console.log(item.id, "2");
            this.filterItems.sort((a, b) => {
              return Number(b.id) - Number(a.id);
            });
            break;
          case 3:
            console.log(item.id, "3");
            this.filterItems.sort((a, b) => {
              return a.fullPricexls - b.fullPricexls;
            });
            break;
          case 4:
            console.log(item.id, "4");
            this.filterItems.sort((a, b) => {
              return b.fullPricexls - a.fullPricexls;
            });
            break;
        }
        this.sortMenu = false;
      } catch (error) {
        console.log({ error });
      }
    },
    сhangeList() {
      this.isList = !this.isList;
      if (this.isList) this.typeItems = "Карточки";
      else this.typeItems = "Список";
    },
    deleteSelectItems() {
      try {
        for (const item of this.$store.state.selectItems) {
          item.selected = false;
        }
        this.$store.commit(
          "newSelectItems",
          this.$store.state.selectItems.filter((e) => e.selected)
        );
        this.options = false;
      } catch (error) {
        console.log({ error });
      }
    },
    async presentationAdd(type) {
      try {
        console.log("presentationAdd");
        this.loading = true;
        let formData = new FormData();
        for (let i = 0; i < this.$store.state.selectItems.length; i++) {
          const item = this.$store.state.selectItems[i];
          item.currencyArr = ["RUB", item.currency];
          for (const index in item) {
            formData.append(`cards[${i}][${index}]`, item[index]);
          }
          formData.append(`cards[${i}][presType]`, type);
        }

        const res = await axios.post(
          "https://lissearch.ru/backend/presentation/create_presentation.php",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        //  console.log({ res });
        let name = `Презентация ${this.$store.state.selectItems.length} объектов.pdf`;
        if (this.$store.state.selectItems.length < 2) {
          name = `${this.$store.state.selectItems[0].name}-${this.$store.state.selectItems[0].square} m2.pdf`;
        }
        const link = document.createElement("a");
        link.href = res.data;
        link.download = name;
        this.loading = false;
        link.click();
        //window.open(link, "_blank");
      } catch (error) {
        console.log({ error });
      }
    },
    pause(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async addSelection() {
      let url = "https://client.lissearch.ru/?";
      const objs = this.$store.state.selectItems;
      console.log({ objs });
      for (const indexObj in objs) {
        if (indexObj == 0) {
          url += `id=${objs[indexObj].id}`;
        } else {
          url += `&id=${objs[indexObj].id}`;
        }
      }
      const clickru = await axios.get("https://clck.ru/--", {
        params: { url },
      });
      const saveUrl = clickru.data;
      this.urlCopy = saveUrl;

      await this.pause(1);

      this.isUrlCopy = true;
      console.log({ saveUrl });
      copy(this.urlCopy);
      this.options = false;
    },
    getOptions() {
      try {
        this.options = true;
      } catch (error) {
        console.log({ error });
      }
    },
  },
  computed: {
    isPress() {
      return this.$store.state.selectItems.length > 0;
    },
  },
  async mounted() {
    console.log(this.item, "item");
    if (this.item.items.length > 0) {
      this.items = this.item.items;
      this.filterItems = this.items;
    } else {
      await this.getItems();
    }
    if (!this.$store.state.isMobile) {
      this.isList = false;
      this.typeItems = "Список";
    }
  },
};
</script>
<style scoped>
.search__block {
  justify-content: space-between;
}
.search {
  margin-right: 0;
}
.search__desctop {
  width: 100%;
}
.v-list-item__prepend {
  display: block;
}
</style>
